import { render } from "./Person.vue?vue&type=template&id=89f4b6f6&scoped=true"
import script from "./Person.vue?vue&type=script&lang=js"
export * from "./Person.vue?vue&type=script&lang=js"

import "./Person.vue?vue&type=style&index=0&id=89f4b6f6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-89f4b6f6"

export default script